import {
    GET_LIST_VIEW_PHONENUMBER
} from '../actions/types';

/**
 * initial state
 */
const INIT_STATE = {
    list: [],
    pagination: {
        currentPage: 1,
        total: 0, // total records
        perPage: 30
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LIST_VIEW_PHONENUMBER: {
            return {
                ...state,
                list: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload.current_page),
                    total: parseInt(action.payload.total),
                    perPage: parseInt(action.payload.per_page),
                }
            }
        }
        default: return { ...state };
    }
}
